"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
const Headers = {
    NextRewrite: 'x-middleware-rewrite',
    NextResume: 'x-middleware-next',
    NextRedirect: 'Location',
};
exports.constants = {
    Headers,
};
